/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { analysisActions } from "../../../redux/slice/analysis.slice";
import { authActions } from "../../../redux/slice/auth.slice";
import { GET_BONDS, GET_FAVOURITES, GET_HISTORIC_DATA, GET_MARKET_CAP } from "../../../redux/types/analysis.types";
import CanadianBonds from "./Design/CanadianBonds";
import FavoritesList from "./Design/FavoritesList";
import MarketSentiment from "./Design/MarketSentiment";
import YieldCurve from "./Design/YieldCurve";

const Dashboard = () => {
  const dispatch = useDispatch()
  const historicData = useSelector(analysisActions.selectors.getHistoricData);
  const marketCap = useSelector(analysisActions.selectors.getMarketCap);
  const searchTicker = useSelector(analysisActions.selectors.getsearchTicker);
  const favouritesComps = useSelector(analysisActions.selectors.getFavourites);
  const bonds = useSelector(analysisActions.selectors.getBonds)
  const currentUser = useSelector(authActions.selectors.getCurrentUser)
  const [historyPayload, setHistoryPayload] = useState({
    symbol: 'TSLA',
    period: '1y',
    interval: '1d'
  })
  const handleHistoryPayload = (name , value) => {
    setHistoryPayload((prevState) => {
      const payload = {
        ...prevState,
        [name]: value
      }
      getHistoricData(payload)
      return payload
    })
   }

  const getHistoricData = useCallback((payload) => {
    dispatch({ type: GET_HISTORIC_DATA, payload: payload });
  }, [dispatch])

  useEffect(() => {
    getHistoricData({
      symbol: 'TSLA',
      period: '1y',
      interval: '1d'
    });
  }, [getHistoricData])

  useEffect(() => {
    dispatch({ type: GET_FAVOURITES, payload: { userid: '65faa99295bb9e17f480ca5f' } })
    dispatch({ type: GET_MARKET_CAP });
    dispatch({ type: GET_BONDS });
  }, [dispatch]);

  const [selectedMarkup, setSelectedMarkup] = useState({})
  const handleMarkupClick = (company) => {
    const payload = {
      ...historyPayload,
      symbol: company?.ticker
    }
    setHistoryPayload(payload);
    getHistoricData(payload);
    setSelectedMarkup(company);
  }

  useEffect(() => {
    if (marketCap?.length) {
      setSelectedMarkup(marketCap?.[0]);
    }
  }, [marketCap?.length]);


  useEffect(() => {
    if (Object.keys(searchTicker)?.length) {
      setHistoryPayload((prevState) => {
        const payload = {
          ...prevState,
          symbol: searchTicker?.["Ticker Symbol"]
        }
        getHistoricData(payload)
        return payload
      })
    }
  }, [getHistoricData, searchTicker]);



  return (
    <div className="bg-[#F5F7F9] w-full p-6 flex flex-col gap-6">
      <FavoritesList favouritesComps={favouritesComps} />
      <CanadianBonds bonds={bonds} />
      <YieldCurve historicData={historicData} marketCap={marketCap} handleMarkupClick={handleMarkupClick} handleHistoryPayload={handleHistoryPayload} selectedMarkup={selectedMarkup} historyPayload={historyPayload} />
      <MarketSentiment />
    </div>
  );
};

export default Dashboard;
